export enum StyledNumberColor {
    green = 'green',
    red = 'red',
}

export interface IStyledNumberProps {
    value: number;
    color?: StyledNumberColor;
}
